export enum NotificationType {
  CLOSED = "CLOSED",
  NEW_CASE = "NEW_CASE",
  NEW_COMMENT = "NEW_COMMENT",
  PARTIAL_ACCEPT = "PARTIAL_ACCEPT",
  PARTIAL_REJECT = "PARTIAL_REJECT",
}
